import React, { useState, useEffect } from "react";
import 'select2/dist/css/select2.min.css';
import { Button } from "react-bootstrap";
import 'select2';
import { Form, Link } from "react-router-dom";
import LocationSearch from "./LocationSearch";
import { each } from "jquery";
import { getservices, getspecialities } from "../../../../services/apiService";
import Select from 'react-select';
import '../../../../assets/styles/Styles.css'
import he from 'he';
import { oneKlicks } from "../../../../SDK/oneclick";
import { debugLog } from "../../../../utils/debug";


const PageSerch = ({ location, setLocation, searchTerm, setSearchTerm = () => { }, selectedSpeciality, setSelectedSpeciality = () => { }, selectedService, setSelectedService = () => { } , otherlocation}) => {
    console.log("PageSerch location :", location);
    const [advancedSearchVisible, setAdvancedSearchVisible] = useState(false);
    const [specialities, setSpecialities] = useState([]);
    const [services, setServices] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchSpecialities();
        fetchServices();
    }, []);

    useEffect(() => {
        if (selectedSpeciality) {
            fetchServices();
        }
    }, [selectedSpeciality]);

    const fetchSpecialities = async () => {
        try {
            const getSpecialities = await oneKlicks.read("", "specialities", {}, "id ASC", "", "", "");
            if (getSpecialities.success && getSpecialities.data) {
                setSpecialities(getSpecialities.data);
            } else {
                throw new Error("Failed to load specialities");
            }
        } catch (error) {
            setError("Failed to load specialities. Please try again.");
        }
    };

    const fetchServices = async () => {
        try {
            const getServices = await oneKlicks.read("", "services", {}, "id ASC", "", "", "");
            if (getServices.success && getServices.data) {
                setServices(getServices.data);
            } else {
                throw new Error("Failed to load services");
            }
        } catch (error) {
            setError("Failed to load services. Please try again.");
        }
    };

    const toggleAdvancedSearch = () => {
        setAdvancedSearchVisible(!advancedSearchVisible);
    };

    const handleLocationChange = (newLocation) => {
        console.log("handleLocationChange newLocation :", newLocation);
        console.log("otherlocation :", otherlocation);
        if (otherlocation) {
            return;
        }
        if (setLocation) {
            console.log("handleLocationChange setLocation :", newLocation);
            setLocation(newLocation);
        }
    };

    const specialityOptions = specialities.map(item => {
        return {
            value: item.id,
            label: he.decode(item.name), // decode &amp; to &
        };
    });
    debugLog('Final specialityOptions:', specialityOptions);


    const filteredServiceOptions = services
        .filter(service => {
            // Show all if none selected, else filter by meta.speciality
            return !selectedSpeciality || service.speciality_id === selectedSpeciality;
        })
        .map(service => ({
            value: service.id,
            label: he.decode(service.name), // decode &amp; to &
        }));

    const handleOptionSelect = (selectedOption) => {
        setSelectedSpeciality(selectedOption?.value || null);
    };

    return (
        <>
            <div className="dc-innerbanner-holder dc-haslayout dc-open dc-opensearchs">
                <div className="">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="dc-innerbanner">
                                    <div className="dc-formtheme dc-form-advancedsearch dc-innerbannerform">
                                        <fieldset className="row justify-content-between">
                                            <div className="col-lg-8 col-sm-8 col-md-6 col-xl-6 p-0">
                                                <div className="form-group col-lg-6 col-sm-4 d-none d-md-block">
                                                    <LocationSearch
                                                        location={location}
                                                        setLocation={handleLocationChange}
                                                    />
                                                </div>
                                                <div className="form-group col-lg-6 col-sm-6">
                                                    <input type="hidden" name="searchby" className="form-control" value="both" />
                                                    <input type="text" name="keyword" className="form-control" placeholder="Search doctors, clinics, hospitals, etc." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                                </div>
                                            </div>

                                            <div className="form-group col-lg-4 col-sm-4 d-flex"  style={{ alignItems: 'end',display: 'flex',justifyContent: 'flex-end' }}>
                                                <div className="h-40">
                                                    <Button type="submit" className="dc-btn h-40 text-white" value="Search">
                                                        <i className="fa fa-search"></i>
                                                        <span className="dc-advance-search-text">Search</span>
                                                    </Button>
                                                </div>
                                                <a href="#" onClick={toggleAdvancedSearch} className="dc-docsearch">
                                                    <span className="dc-advanceicon">
                                                        <i></i> <i></i> <i></i>
                                                    </span>
                                                    <span className="dc-advance-search-text">Advanced <br /> Search</span>
                                                </a>
                                            </div>

                                        </fieldset>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`dc-advancedsearch-holder ${advancedSearchVisible ? 'show ' : ''}`} >
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="dc-advancedsearchs">
                                <div className="dc-formtheme dc-form-advancedsearchs">
                                    <fieldset>
                                        <div className="form-group">
                                            <Select
                                                options={specialityOptions}
                                                placeholder="Select a speciality"
                                                onChange={handleOptionSelect}
                                                isSearchable
                                                styles={customStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <Select
                                                options={filteredServiceOptions}
                                                placeholder="Select a Service"
                                                onChange={(selectedOption) => {
                                                    debugLog('Selected:', selectedOption);
                                                    setSelectedService(selectedOption?.value || null);
                                                }}
                                                value={selectedService}
                                                isSearchable
                                                styles={customStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                        </div>
                                        <input type="hidden" name="orderby" className="search_orderby" value="" />
                                        <input type="hidden" name="order" className="search_order" value="ASC" />
                                        <div className="dc-btnarea">
                                            <Link to="/search-doctors" className="dc-btn dc-resetbtn">Reset Filters</Link>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#3d4461',
        minHeight: '44px',
        maxHeight: '44px',
        borderColor: state.isFocused ? '#4e5779' : '#4e5779',
        boxShadow: state.isFocused ? '0 0 0 1px #4e5779' : 'none',
        '&:hover': {
            borderColor: '#4e5779',
        },
        cursor: 'pointer',
    }),
    input: (provided) => ({
        ...provided,
        color: '#fff',
        margin: '0',
        padding: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#fff',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#fff',
        margin: '0',
        padding: '0',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        backgroundColor: '#3d4461',
        marginTop: '4px',
        position: 'absolute',
        width: '100%',
    }),
    menuList: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#4e5779' : '#3d4461',
        color: '#fff',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#4e5779',
        },
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
    }),
};

export default PageSerch;
